import { render, staticRenderFns } from "./ListPerson_academic_degree.vue?vue&type=template&id=03590c76&scoped=true"
import script from "./ListPerson_academic_degree.vue?vue&type=script&lang=js"
export * from "./ListPerson_academic_degree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03590c76",
  null
  
)

export default component.exports